<template>
  <div class="py-3 bg-light">
    <ERTPRoadtrip
      v-if="roadtrip"
      :roadtrip="roadtrip"
      :adId="adId"/>
  </div>

  <ERTPResultMessage/>
</template>

<script setup lang="ts">
import { clientOnly } from 'vike-vue/clientOnly'
import { useData } from 'vike-vue/useData'
import { Roadtrip } from "../../../models/roadtrip";
import { usePageContext } from 'vike-vue/usePageContext';
import { useRoadtrip } from '../../../composables/roadtrip';

const ERTPRoadtrip = clientOnly(() => import('../../../components/ERTPRoadtrip.vue'));
const ERTPResultMessage = clientOnly(() => import('../../../components/ERTPResultMessage.vue'));

const pageContext = usePageContext();
const adId: string | undefined = pageContext.urlParsed.search["adId"];

 const data = useData<{roadtrip: Roadtrip}>();
 const { roadtrip } = useRoadtrip();
 roadtrip.value = data.roadtrip;
</script>
